import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchPreviewUser, } from '../../../actions/Users/UserAction';
import AddUser from './AddUser';

const EditUser = () => {
  const [isEnable, setIsEnable] = useState(false);
  const previewUser = useSelector((state) => state.Users.previewUser);
  const [userGuid, setUserGuid] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
  setUserGuid(queryParams?.guid);

  dispatch(fetchPreviewUser(queryParams?.guid));

  if (queryParams?.guid === previewUser.guid) {
    setIsEnable(queryParams.isEnable === 'true');
  }
}, [location.search]);

return (
  <AddUser
    className={'editUser'}
    userGuid={userGuid}
    isEdit={!isEnable}
    isEnable={isEnable}
  />
);
}

export default EditUser;
